import clsx from 'clsx';
import React from 'react';

import IconDeepResearch from '@components/Images/DeepResearch/IconDeepResearch';

import './styles.scss';

// `small` renders a compact throbbing sparkle — the low-key "still working"
// indicator shown under streaming content (Claude-style). It keeps the brand's
// double-star mark, just scaled down. The default is the original larger double
// sparkle used on standalone loading states.
const SparkleSpinner = ({ className, small = false }: { className?: string; small?: boolean }) => {
  if (small) {
    return (
      <div
        className={clsx('sparkle-spinner relative w-[22px]', className)}
        data-testid="sparkle-spinner"
      >
        <IconDeepResearch className="text-pro-gold" width={16} height={16} />
        <IconDeepResearch
          className="absolute -right-2 -top-4 text-pro-gold"
          width={10}
          height={10}
        />
      </div>
    );
  }

  return (
    <div
      className={clsx('sparkle-spinner relative mx-auto w-40', className)}
      data-testid="sparkle-spinner"
    >
      <IconDeepResearch className="text-pro-gold" width={32} height={32} />
      <IconDeepResearch
        className="absolute -right-2 -top-10 text-pro-gold"
        width={20}
        height={20}
      />
    </div>
  );
};

export default SparkleSpinner;
